export default __webpack_public_path__ + "static/media/EPP2.a08ccdfa.png";